<div class="container-fluid">
  <div class="row">
    <div class="col-lg-12">
      <h3 class="page-header">View Combo Permissions</h3>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-12 col-lg-6">
      <b>User:</b> &nbsp;
      <aims-lookup name="User"
        style="width:50%"
        [gridText]="'Select a User'"
        id="userNameLookup"
        [values]="users | async"
        [idPropertyName]="'userId'"
        [displayPropertyName]="'userName'"
        [columnsInGrid]="userLookupColumns"
        [altDisplay]="user?.value.user"
        (valueChangeObj)="handleUserLookupChange($event)"
        >
      </aims-lookup>
</div>
    <!-- <div class="col-xs-12 col-lg-6">
      PASSWORD EXPIRES IN {{ passwordExp | async }} DAYS
    </div> -->
  </div>

  <div class="row top20">
    <form novalidate #permGrid="ngForm" *ngIf="permissionsReport | async">
      <aims-common-table
        id="PermissionsReport"
        [dataSource]="permissionsReportDataSource"
        [header]="permissionsReportColumns"
        [permissions]="permissions"
        [stickyHeader]="true"
        [exportFunction]="getForExcel"
        [pageSize]="10"
      >
        <aims-common-table-dynamic-row id="componentId">
          <ng-template viewMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
              {{ element.componentId | getText:'componentId':'component':componentValues }}
          </ng-template>
        </aims-common-table-dynamic-row>

        <!--Create-->
        <aims-common-table-dynamic-row id="createProvider">
          <ng-template viewMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
            {{ (element.createProvider == null && element.create) ? 'User' : element.createProvider | getText:'permissionGroupId':'permissionGroupName':groupValues }}
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="create">
          <ng-template viewMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
            <div class="text-center">
              <ng-container *ngIf="element.create === true">
                <img src="{{imgSrc}}/check.png" style="width:20px" />
              </ng-container>
              <ng-container *ngIf="!element.create">
                <img src="{{imgSrc}}/X.png" style="width:20px" />
              </ng-container>
            </div>
          </ng-template>
        </aims-common-table-dynamic-row>

        <!--Read-->
        <aims-common-table-dynamic-row id="readProvider">
          <ng-template viewMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
            {{ (element.readProvider == null && element.read) ? 'User' : element.readProvider | getText:'permissionGroupId':'permissionGroupName':groupValues }}
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="read">
          <ng-template viewMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
              <div class="fullWidth text-center">
                <ng-container *ngIf="element.read">
                  <img src="{{imgSrc}}/check.png" style="width:20px" />
                </ng-container>
                <ng-container *ngIf="!element.read">
                  <img src="{{imgSrc}}/X.png" style="width:20px" />
                </ng-container>
              </div>
          </ng-template>
        </aims-common-table-dynamic-row>

        <!--Update-->
        <aims-common-table-dynamic-row id="updateProvider">
          <ng-template viewMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
            {{ (element.updateProvider == null && element.update) ? 'User' : element.updateProvider | getText:'permissionGroupId':'permissionGroupName':groupValues }}
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="update">
          <ng-template viewMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
            <div class="fullWidth text-center">
              <ng-container *ngIf="element.update">
                <img src="{{imgSrc}}/check.png" style="width:20px" />
              </ng-container>
              <ng-container *ngIf="!element.update">
                <img src="{{imgSrc}}/X.png" style="width:20px" />
              </ng-container>
            </div>
          </ng-template>
        </aims-common-table-dynamic-row>

        <!--Delete-->
        <aims-common-table-dynamic-row id="deleteProvider">
          <ng-template viewMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
            {{ (element.deleteProvider == null && element.delete) ? 'User' : element.deleteProvider | getText:'permissionGroupId':'permissionGroupName':groupValues }}
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="delete">
          <ng-template viewMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
            <div class="fullWidth text-center">
              <ng-container *ngIf="element.delete">
                <img src="{{imgSrc}}/check.png" style="width:20px" />
              </ng-container>
              <ng-container *ngIf="!element.delete">
                <img src="{{imgSrc}}/X.png" style="width:20px" />
              </ng-container>
            </div>
          </ng-template>
        </aims-common-table-dynamic-row>
      </aims-common-table>
    </form>
  </div>


  <aims-spinner [spinnerText]="spinnerText" [showSpinner]="showSpinner"></aims-spinner>
</div>
